import assign from 'lodash/assign';

// service worker
import CONFIG from 'app/client/workers/config';

import DispatchConstants from 'app/shared/constants/DispatchConstants';
import sharedConfig from 'app/shared/sharedConfig';
import { getServices } from 'app/shared/utils/serviceUtils';
import browserUtils from 'app/shared/utils/browserUtils';
import constellationBrowserUtils from 'app/shared/utils/constellationBrowserUtils';

const initState = () => ({
    brand: sharedConfig.defaultBrand,
    hostname: sharedConfig.brandHostnames[sharedConfig.defaultBrand],
    version: sharedConfig.version,
    cookieEnabledServices: getServices(),
    isDev: false,
    isMobile: false,
    isOnline: null,
    // FIXME: remove isSOH prop
    isSOH: true,
    screenSize: 'xl',
    constellationScreenSize: 'xl',

    // DESTRUCTIVE: should redirect the app and end this req.
    // this should never be populated on the client!!
    serverSideRedirectUrl: '',

    swVersion: CONFIG.DEFAULT_VERSION,
    userAgent: '',
    prevPage: '',
    ip: '',
    isRunningInProd: false,
    csrfToken: '',
});

const app = (state = initState(), action = {}) => {
    const { type, payload } = action;

    switch (type) {
    // case has no effect on state
        case DispatchConstants.TRANSITION_TO:
            return state;

        case DispatchConstants.UPDATE_APP:
            return assign({}, state, payload);
        case DispatchConstants.SCREEN_DIMENSION_CHANGE: {
            const screenSize = browserUtils.screen.size(payload.screenWidth);
            const constellationScreenSize = constellationBrowserUtils.screen.size(payload.screenWidth);
            if (state.screenSize === screenSize) {
                return state;
            }

            return {
                ...state,
                screenSize,
                constellationScreenSize,
            };
        }
        case DispatchConstants.INITIALIZE_FEATURE_FLAGS:
            return {
                ...state,
                cookieEnabledServices: payload,
            };
        case DispatchConstants.UPDATE_FEATURE_FLAG:
            return {
                ...state,
                cookieEnabledServices: {
                    ...state.cookieEnabledServices,
                    [payload.feature]: payload.featureValue,
                },
            };
        default:
            return state;
    }
};

export default app;
